// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1031":"ccaad962362e492a","3288":"0755b38ae9c0eeff"}[chunkId] + ".js";
};